import { useQuery } from 'react-query';
import { GenderAPI } from 'api/admin/gender';
import { GENDERS } from 'helpers/constants';

export default function useGenders() {
  return useQuery(GENDERS, GenderAPI.getAll);
}
